import { render, staticRenderFns } from "./SincronizarPontos.vue?vue&type=template&id=208d1d6a"
import script from "./SincronizarPontos.vue?vue&type=script&lang=js"
export * from "./SincronizarPontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports